import React from "react";
import { ContentBody } from 'areas/shared/components';
import { Box } from "fw/components";
import Search from './Search';
import CompanyInfoTab from './connectToSponsorsInfo/ConnectToSponsorsInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import * as Formatter from 'fw/components/formatter/Formatter';

class ConnectToSponsors extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }

    render() {
        let opts = {
            setupKey: "sponsorSetup",
            title: "Lookup VOCS Corporate Members – ",
            description: "Search for VOCS Certified Corporate Members",
            enableColumnSettings: true,
            recentType: "connectToSponsors",
            enableExport: true,
            showTitle: false,
            showButtons: {
                cancel: false,
                save: false
            },
            disableSelect: true,
            list: {
                url: API.Biz.url('/vobSetup/searchSponsor'),
                rowKey: "sponsorId",
                columns: [
                    { key: 'sponsorName', name: 'Company Name', sortable: true },
                    { key: 'address', name: 'Address', sortable: true },
                    { key: 'website', name: 'Website', formatter: Formatter.ExternalLink, getRowMetaData: (row) => ({url: row.website, title: row.website, targetBlank: true}), sortable: true }
                ]
            },
            tabs: [
                { key: "companyInfo", title: "Company Info", comp: CompanyInfoTab }
            ]
        };

        return (
            <React.Fragment>
                <ContentBody>
                    <Box>
                        <SetupPage {...opts} Search={Search} />
                    </Box>
                </ContentBody>
            </React.Fragment >
        );
    }
}

export default ConnectToSponsors;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToSponsors/ConnectToSponsors.js